import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { OM_LOGO, MTN_LOGO, OPERATOR_COLORS } from "../assets/logos";
import Card from "../components/ui/Card";

export default function Profile() {
  const navigate = useNavigate();
  const { linkedNums, addLinkedNum, removeLinkedNum, setDefaultNum } = useApp();
  const [showAdd, setShowAdd] = useState(false);
  const [newOp, setNewOp] = useState("o");
  const [newNum, setNewNum] = useState("");

  const handleAdd = () => {
    const v = newNum.trim();
    if (!v) return;
    addLinkedNum(newOp, v);
    setNewNum("");
    setShowAdd(false);
  };

  return (
    <div className="bg-[#f0f2f7] pb-2 screen-enter">
      {/* Header */}
      <div className="bg-brand-dark px-[17px] pt-[17px] pb-6">
        <div className="flex items-center gap-3">
          <div className="w-[50px] h-[50px] rounded-[14px] bg-brand-orange flex items-center justify-center text-[17px] font-extrabold text-white flex-shrink-0">
            JN
          </div>
          <div>
            <p className="text-white text-[15px] font-bold mb-0.5">Jean-Paul Nkomo</p>
            <p className="text-white/60 text-[11px]">+237 699 XXX XXX</p>
          </div>
        </div>
      </div>

      <div className="px-3 mt-[-12px]">
        {/* Numéros liés */}
        <Card padding={false} className="mb-3">
          <div className="p-3 border-b border-gray-100">
            <div className="flex justify-between items-center mb-2.5">
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-[0.7px]">
                Numéros liés
              </p>
              <button
                onClick={() => setShowAdd((v) => !v)}
                className="bg-brand-orange text-white border-none text-[10px] font-bold px-[9px] py-1 rounded-md cursor-pointer tap-highlight"
              >
                <i className="fa fa-plus mr-1" style={{ fontSize: 8 }} />
                Ajouter
              </button>
            </div>

            {/* Liste numéros */}
            {linkedNums.length === 0 ? (
              <p className="text-xs text-gray-400 text-center py-1">Aucun numéro lié</p>
            ) : (
              linkedNums.map((n, i) => {
                const col = OPERATOR_COLORS[n.op];
                const logo = n.op === "o" ? OM_LOGO : MTN_LOGO;
                return (
                  <div
                    key={i}
                    className="flex items-center gap-[9px] py-2.5 border-b border-gray-50 last:border-b-0"
                  >
                    <div
                      className="w-[30px] h-[30px] rounded-lg flex items-center justify-center flex-shrink-0 border"
                      style={{ background: col.light, borderColor: col.border }}
                    >
                      <img src={logo} alt="" style={{ height: n.op === "o" ? 14 : 12 }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex gap-1 mb-0.5">
                        <span
                          className="text-[9px] font-bold px-1.5 py-0.5 rounded-[5px]"
                          style={{ background: col.light, color: col.primary }}
                        >
                          {col.name}
                        </span>
                        {n.def && (
                          <span className="text-[9px] font-bold px-1.5 py-0.5 rounded-[5px] bg-brand-success-light text-brand-success">
                            Défaut
                          </span>
                        )}
                      </div>
                      <p className="text-xs font-semibold text-brand-dark">+237 {n.num}</p>
                    </div>
                    <div className="flex gap-1">
                      {!n.def && (
                        <button
                          onClick={() => setDefaultNum(i)}
                          className="bg-gray-100 border-none text-gray-700 text-[9px] font-bold px-1.5 py-1 rounded-[5px] cursor-pointer tap-highlight"
                        >
                          Défaut
                        </button>
                      )}
                      <button
                        onClick={() => removeLinkedNum(i)}
                        className="bg-brand-danger-light border-none text-brand-danger text-[9px] px-1.5 py-1 rounded-[5px] cursor-pointer tap-highlight"
                      >
                        <i className="fa fa-trash-alt" />
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Panneau ajout */}
          {showAdd && (
            <div className="p-3 bg-brand-orange-light border-t border-brand-orange-border">
              <p className="text-[11px] font-bold text-brand-orange mb-2">
                <i className="fa fa-plus-circle mr-1" />
                Ajouter un numéro
              </p>
              <div className="grid grid-cols-2 gap-1.5 mb-2">
                {["o", "m"].map((op) => {
                  const c = OPERATOR_COLORS[op];
                  return (
                    <button
                      key={op}
                      onClick={() => setNewOp(op)}
                      className="border-none text-[11px] font-bold py-[7px] rounded-lg cursor-pointer transition-colors tap-highlight"
                      style={{
                        background: newOp === op ? c.primary : "#e5e7eb",
                        color: newOp === op ? "white" : "#6b7280",
                      }}
                    >
                      {c.name}
                    </button>
                  );
                })}
              </div>
              <div className="flex gap-1.5 mb-2">
                <div className="flex items-center px-2.5 rounded-lg bg-gray-100 border border-gray-200 text-[11px] font-bold text-gray-600 flex-shrink-0">
                  +237
                </div>
                <input
                  type="tel"
                  placeholder="6XX XXX XXX"
                  value={newNum}
                  onChange={(e) => setNewNum(e.target.value)}
                  className="flex-1 border border-gray-200 rounded-[9px] px-3 py-[9px] text-xs outline-none focus:border-brand-orange bg-white"
                />
              </div>
              <button
                onClick={handleAdd}
                className="w-full bg-brand-dark text-white border-none text-xs font-bold py-[9px] rounded-[9px] cursor-pointer tap-highlight"
              >
                Confirmer l'ajout
              </button>
            </div>
          )}
        </Card>

        {/* Menu */}
        <Card padding={false}>
          {[
            { icon: "fa-bell", label: "Notifications", color: "#6b7280", bg: "#f3f4f6" },
            { icon: "fa-lock", label: "Sécurité", color: "#6b7280", bg: "#f3f4f6" },
            { icon: "fa-headset", label: "Support", color: "#FF6200", bg: "#fff7f0", border: "#ffe0c4", onClick: () => navigate("/support") },
            { icon: "fa-sign-out-alt", label: "Se déconnecter", color: "#dc2626", bg: "#fef2f2", danger: true },
          ].map(({ icon, label, color, bg, border, onClick, danger }, i, arr) => (
            <div
              key={label}
              onClick={onClick}
              className={`px-[13px] py-[11px] flex items-center gap-2.5 ${onClick ? "cursor-pointer" : ""} ${i < arr.length - 1 ? "border-b border-gray-100" : ""}`}
            >
              <div
                className="w-[30px] h-[30px] rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ background: bg, border: border ? `1px solid ${border}` : "none" }}
              >
                <i className={`fa ${icon}`} style={{ color, fontSize: 12 }} />
              </div>
              <span
                className="flex-1 text-xs font-semibold"
                style={{ color: danger ? "#dc2626" : "#0d0d1a" }}
              >
                {label}
              </span>
              {!danger && (
                <i className="fa fa-chevron-right text-gray-200" style={{ fontSize: 10 }} />
              )}
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
